module.exports = Vue;


//////////////////
// WEBPACK FOOTER
// external "Vue"
// module id = lRwf
// module chunks = 6